"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTableComponent = exports.DataTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _muiDatatables = _interopRequireDefault(require("mui-datatables"));
var _styles = require("@material-ui/core/styles");
var _StyledTooltip = require("../StyledTooltip");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//Supporting items for MUIDataTable

var DataTable = exports.DataTable = {
  //Header of the table
  headerProps: function headerProps(backgroundColor) {
    return {
      style: {
        paddingLeft: '5px',
        paddingTop: '5px',
        border: '1px solid #222222',
        backgroundColor: backgroundColor
      }
    };
  },
  //Body cells for the first  column
  firstCellProps: function firstCellProps() {
    return {
      style: {
        paddingRight: '5px',
        borderLeft: '1px solid gray',
        boxShadow: '0.25px 0 0 #818181'
      }
    };
  },
  //Body cells in the table, except the first & last column
  cellProps: function cellProps() {
    return {
      style: {
        paddingRight: '5px',
        borderLeft: '1px solid lightGray',
        boxShadow: '0.25px 0 0 #818181'
      }
    };
  },
  //Body cells for the last column of the table - for some reason mui-datatable doesn't render these the same?
  lastCellProps: function lastCellProps() {
    return {
      style: {
        paddingLeft: '5px',
        borderLeft: '1px solid lightGray',
        borderRight: '1px solid gray',
        boxShadow: '0.25px 0 0 #818181'
      }
    };
  },
  getRowStyle: function getRowStyle(selectedRow, dataIndex, rowIndex, selectedColor) {
    var alternateRowColor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'white';
    if (selectedRow === dataIndex) {
      return {
        style: {
          backgroundColor: selectedColor
        }
      }; //selected color
    }
    if (rowIndex % 2 !== 0) {
      //slight tint on ever other row, remaining rows white
      return {
        style: {
          backgroundColor: alternateRowColor
        }
      };
    }
    return {};
  },
  longStringCellRenderer: function longStringCellRenderer(val) {
    return longStringRenderer(val, 30);
  },
  longerStringCellRenderer: function longerStringCellRenderer(val) {
    return longStringRenderer(val, 50);
  }
};
var DataTableComponent = exports.DataTableComponent = /*#__PURE__*/function (_Component) {
  function DataTableComponent() {
    var _this;
    _classCallCheck(this, DataTableComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DataTableComponent, [].concat(args));
    _defineProperty(_this, "state", {
      rowsPerPage: 1
    });
    //Based on the number of rows, set the selectable rows per page, with maximum up to 200
    _defineProperty(_this, "_getRowsPerPageArray", function (numRows) {
      var rowsPerPageList = [];

      //Less than 25, only num rows
      if (numRows < 25) rowsPerPageList.push(numRows);else {
        //else, push 25 and keep going
        rowsPerPageList.push(25);

        //less than 100, push num rows
        if (numRows < 100) rowsPerPageList.push(numRows);else {
          //else, push 100 and keep going

          rowsPerPageList.push(100);

          //less than 200, push num rows
          if (numRows < 200) rowsPerPageList.push(numRows);else rowsPerPageList.push(200); //push 200, max allowed
        }
      }
      return rowsPerPageList;
    });
    return _this;
  }
  _inherits(DataTableComponent, _Component);
  return _createClass(DataTableComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      //custom breakpoint for flipping to rows - compact mode
      var flipToRowTable = this.props.flipToRowWidth ? this.props.flipToRowWidth : 600;
      var getMuiTheme = (0, _styles.createMuiTheme)({
        overrides: {
          MUIDataTableSelectCell: {
            root: {
              display: 'none'
            }
          },
          MuiTableFooter: {
            root: {
              backgroundColor: 'white',
              borderTop: '1px solid gray'
            }
          },
          MuiTableRow: {
            root: {
              '&:hover': {
                backgroundColor: this.props.hoverColor
              }
            }
          }
        },
        breakpoints: {
          values: {
            xs: 0,
            sm: 400,
            md: flipToRowTable,
            lg: 1280
          }
        }
      });
      var rowsPerPageOptions = this._getRowsPerPageArray(this.props.data.length);

      //if the current state is in the rowsPerPageOptions array, use it, otherwise use the first element
      var rowsPerPage = this.state.rowsPerPage;
      if (!rowsPerPageOptions.includes(rowsPerPage)) rowsPerPage = rowsPerPageOptions[0];
      var tableOptions = _objectSpread({
        filter: false,
        search: false,
        print: false,
        download: false,
        selectableRowsOnClick: true,
        selectableRows: 'single',
        resizableColumns: false,
        rowHover: false,
        elevation: 0,
        viewColumns: false,
        selectToolbarPlacement: 'none',
        onChangeRowsPerPage: function onChangeRowsPerPage(num) {
          _this2.setState({
            rowsPerPage: num
          });
        },
        rowsPerPageOptions: rowsPerPageOptions,
        rowsPerPage: rowsPerPage,
        setTableProps: function setTableProps() {
          return {
            padding: 'checkbox'
          };
        }
      }, this.props.options);
      var title = this.props.title ? this.props.title : "";
      return /*#__PURE__*/_react["default"].createElement(_styles.MuiThemeProvider, {
        theme: getMuiTheme
      }, /*#__PURE__*/_react["default"].createElement(_muiDatatables["default"], {
        title: title,
        data: this.props.data,
        columns: this.props.columns,
        options: tableOptions
      }));
    }
  }]);
}(_react.Component);
;
var longStringRenderer = function longStringRenderer(val) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  //reduce text size and render in a tooltip instead
  var fullText = val != null ? val : "";
  if (fullText.length > maxLength) {
    var shortText = fullText.substring(0, maxLength - 3) + "...";
    return /*#__PURE__*/_react["default"].createElement(_StyledTooltip.StyledTooltip, {
      title: (0, _StyledTooltip.multilineJSX)(fullText, true)
    }, /*#__PURE__*/_react["default"].createElement("div", null, shortText));
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", null, fullText);
  }
};